export default __webpack_public_path__ + "static/media/Unjust Contract.014ecc07.png";